import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Card, Form, Button, Flex, Input, Select } from "antd";
import { useCreateIncidentMutation } from "./incident.service";
import { useFetchTeamMembersQuery } from "../team/team.service";
import { useTranslation } from "react-i18next";
import "./style.css";

export default function IncidentCreate() {
  const { t } = useTranslation();

  const navigate = useNavigate();

  const [form] = Form.useForm();

  const { data = [] } = useFetchTeamMembersQuery();

  const [requestCreateIncident, { isSuccess, isLoading }] =
    useCreateIncidentMutation();

  useEffect(() => {
    if (isSuccess) {
      form.resetFields();
    }
  }, [isSuccess]);

  const handleFormSubmit = (e) => {
    requestCreateIncident(e);
  };

  return (
    <Card
      className="incident-page"
      bordered={false}
      title={`${t("Incident")} ${t("Create")}`}
      extra={
        <Button onClick={() => navigate("/incidents")}>{t("BACK")}</Button>
      }
    >
      <div className="incident-page-container">
        <Form
          form={form}
          layout="vertical"
          onFinish={handleFormSubmit}
          initialValues={{
            incident: "",
            resolution: "",
            nameofemployee: "",
          }}
        >
          <div>{t("INCIDENT")}</div>
          <Form.Item
            name="incident"
            rules={[
              {
                required: true,
                message: "Please enter an incident",
              },
            ]}
          >
            <Input.TextArea rows={3} />
          </Form.Item>
          <div>{t("RESOLUTION")}</div>
          <Form.Item name="resolution">
            <Input.TextArea rows={3} />
          </Form.Item>
          <div>{t("NAME OF EMPLOYEE")}</div>
          <Form.Item
            name="employeeName"
            rules={[
              {
                required: true,
                message: "Please enter an name of employee",
              },
            ]}
          >
            <Select
              options={data.reduce((arr, cur) => {
                arr.push({ value: cur.name, label: cur.name });
                return arr;
              }, [])}
            />
          </Form.Item>
          <Flex justify="center">
            <Button type="primary" htmlType="submit" loading={isLoading}>
              {t("Submit")}
            </Button>
          </Flex>
        </Form>
      </div>
    </Card>
  );
}
